import { useState, useRef } from "react";
import "../../../assets/css/style.css";
import { ServicesService } from "../../../services/service.service";
import { toast } from "react-toastify";
import { useSite } from "../../../context/SiteContext";
import { SiteData } from "../../../interface/site.interface";
import ReCaptchaWrapper, { ReCaptchaWrapperRef } from "../../Recapture/Recapture";

const Index = () => {
  const { data } = useSite() as { data: SiteData };

  const [formData, setFormData] = useState({
    fullName: "",
    phoneNumber: "",
    productInfo: "",
  });
  const [errors, setErrors] = useState<{ [key: string]: string }>({});

  const [isRecaptchaVerified, setIsRecaptchaVerified] = useState(false);
  const [recaptchaToken, setRecaptchaToken] = useState<string | null>(null);
  const [captchaError, setCaptchaError] = useState("");
  const recaptchaRef = useRef<ReCaptchaWrapperRef>(null);

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { id, value } = e.target;
    setFormData((prev) => ({ ...prev, [id]: value }));
    setErrors((prev) => ({ ...prev, [id]: "" }));

    const snakeCaseKey = id.replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`);

    setErrors((prevErrors) => {
      const updatedErrors = { ...prevErrors };
      delete updatedErrors[snakeCaseKey];
      return updatedErrors;
    });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!isRecaptchaVerified || !recaptchaToken) {
      setCaptchaError("Zəhmət olmazsa, \"Mən robot deyiləm\" seçimini təsdiqləyin");
      return;
    }

    try {
      const payload = {
        full_name: formData.fullName,
        phone_number: formData.phoneNumber,
        product_info: formData.productInfo,
        recaptchaToken,
      };

      await ServicesService.PostPriceOffer(payload);
      toast.success("Müraciətiniz uğurla göndərildi");

      setFormData({ fullName: "", phoneNumber: "", productInfo: "" });
      setErrors({});
      setIsRecaptchaVerified(false);
      setRecaptchaToken(null);
      recaptchaRef.current?.reset();
    } catch (err: any) {
      setErrors(err.errors || {});
    }
  };

  return (
    <div className="sevices-all-color">
      <div className="services-all-contact">
        <div className="quote-form">
          <h2 className="title">{data?.price_offer}</h2>
          <p className="subtitle">{data?.price_offer_description}</p>

          <form className="form" onSubmit={handleSubmit}>
            <div className="form-group">
              <div className="input-field">
                <label htmlFor="fullName">{data?.name_surname}</label>
                <input
                  id="fullName"
                  type="text"
                  placeholder={data?.name_surname_placeholder}
                  className="input"
                  value={formData.fullName}
                  onChange={handleChange}
                />
                <p className="errorMsg">{errors.full_name}</p>
              </div>
              <div className="input-field">
                <label htmlFor="phoneNumber">{data?.contact_number}</label>
                <input
                  id="phoneNumber"
                  type="number"
                  placeholder={data?.contact_number}
                  className="input"
                  value={formData.phoneNumber}
                  onChange={handleChange}
                />
                <p className="errorMsg">{errors.phone_number}</p>
              </div>
            </div>

            <div className="input-field">
              <label htmlFor="productInfo">{data?.product_about}</label>
              <textarea
                id="productInfo"
                className="textarea"
                placeholder={data?.product_about}
                value={formData.productInfo}
                onChange={handleChange}
              />
              <p className="errorMsg">{errors.product_info}</p>
            </div>

            {/* \u2714\uFE0F ReCAPTCHA */}
            <div className="Submit_btn">
              <div>
                <ReCaptchaWrapper
                  ref={recaptchaRef}
                  onVerify={(token) => {
                    setIsRecaptchaVerified(!!token);
                    setRecaptchaToken(token);
                    setCaptchaError("");
                  }}
                />
                {captchaError && (
                  <p style={{ color: "red", fontWeight: 500, fontSize: 14 }}>
                    {captchaError}
                  </p>
                )}
              </div>
              <div className='Submit_div'>
                <button type="submit" className="submit-buttonn">
                  {data?.send_message}
                </button>
              </div>
            </div>

          </form>
        </div>
      </div>
    </div>
  );
};

export default Index;
